import { render, staticRenderFns } from "./SharedCollections.vue?vue&type=template&id=2c4ffb68&lang=pug&"
import script from "./SharedCollections.vue?vue&type=script&lang=js&"
export * from "./SharedCollections.vue?vue&type=script&lang=js&"
import style0 from "./SharedCollections.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports